<template>
  <div id="creator_success">
    <van-nav-bar placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-row>
      <van-col span="24" class="creator_success_img">
        <img src="../assets/img/creator_success.png"/>
      </van-col>
      <van-col span="24" class="creator_success_text">The review has been passed. </van-col>
      <van-col span="16" offset="4" class="creator_success_btn">
        <van-button color="linear-gradient(to left, #FF61F5, #A529FF)" round block @click="onClickLeft">{{ $t('column.return')}}</van-button>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
export default {
  data() {
    return {}
  },
  created() {},
  methods: {
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/creator_success.vue